<template>
  <ValidationObserver>
    <div id="password-reset-view">
      <v-content>
        <v-container>
          <v-layout justify-center row wrap>
            <v-flex xs12 sm8 md6>
              <v-card
                max-width="800px"
                elevation=24
              >
                <v-toolbar dark color="primary">
                  <v-toolbar-title>{{ title }}</v-toolbar-title>
                </v-toolbar>

                <v-layout align-center justify-center row fill-height>
                  <router-link to="/">
                    <img :src="require('../assets/fuzzcv-logo.png')" alt="fuzzcv curriculum vitae CV automatique en ligne" width="400" class="mt-3">
                  </router-link>
                </v-layout>

                <v-card-text class="subheading">
                  {{ explainText }}
                </v-card-text>

                <v-layout align-center justify-center row fill-height
                          v-if="emailLoading"
                >
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    indeterminate
                    color="primary"
                    class="text-xs-center mb-5"
                  ></v-progress-circular>
                </v-layout>

                <v-form
                  v-else-if="!emailCompleted"
                >
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                          <ValidationProvider name="email" rules="required|email">
                            <v-text-field
                              slot-scope="{
                                          errors,
                                          valid
                                          }"
                              :error-messages="errors"
                              :success="valid"
                              v-model="inputs.email"
                              v-bind:label=labelMail
                              required
                            >
                            </v-text-field>
                          </ValidationProvider>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-layout wrap>
                      <v-flex xs12 >
                        <div class="mb-3">
                          <v-alert v-show="emailError"
                                   :value="true"
                                   type="warning"
                                   class="mb-2"
                          >
                            {{ emailErrorRaison }}
                          </v-alert>
                        </div>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-layout align-center justify-space-between row fill-height>
                        <v-btn color="info" @click="sendPasswordResetEmail(inputs)">{{ buttonLabel }}</v-btn>
                        <small>{{ required_fields }}</small>
                      </v-layout>


                    </v-layout>
                  </v-card-actions>
                </v-form>
                <v-card-text v-else>
                  <v-flex xs12>
                    <div class="mt-3">
                      <v-alert
                        :value="true"
                        type="success"
                      >
                        {{ successMsg }}
                      </v-alert>
                      <div>
                        <router-link to="/login">{{ backToPageLabel }}</router-link>
                      </div>
                    </div>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </div>
  </ValidationObserver>
</template>

<script>
 import {
   ValidationObserver,
   ValidationProvider,
   withValidation
 } from "vee-validate";
 import { mapActions, mapState } from 'vuex';

 export default {
   components: {
     ValidationProvider,
     ValidationObserver
   },
   data() {

     return {
       inputs: { email: '' },
       title: "Ré-initialisation de votre mot de passe.",
       explainText: `Entrez l' adresse email avec laquelle vous vous êtes inscrit.
        Nous allons vous envoyer un email contenant un lien pour réinitialiser votre mot de passe.`,
       labelMail: "Email utilisé lors de l'inscription.*",
       buttonLabel: "Envoyer mail",
       backToPageLabel: "Retourner à la page de login.",
       errorMsg: "Une erreur s'est produite pendant le traitement de votre requête.",
       successMsg: `Consulter votre boîte mail : un lien vous a été envoyé afin de ré-initialiser votre mot de passe.
       Si ce mail n'apparaît pas après quelques minutes, vérifier votre répertoire de spam.`,
       required_fields: `*Champs requis`,
     };
   },
   computed: mapState('password', [
     'emailCompleted',
     'emailError',
     'emailLoading',
     'emailErrorRaison',
   ]),
   methods: mapActions('password', [
     'sendPasswordResetEmail',
     'clearEmailStatus',
   ]),
   beforeRouteLeave(to, from, next) {
     console.log("On PARSSSSSS")
     this.clearEmailStatus();
     next();
   },
   created: function () {
     // `this` points to the vm instance
     this.clearEmailStatus();
   }
 };
</script>

<style>
#password-reset-view {
    background-image: url('../assets/hands-joined-team.jpg');
    /* background-color: #8f2c2c; */
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
</style>
